;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();import { keepPreviousData, queryOptions } from "@tanstack/react-query";
import {
	queryFetcher,
	type RequestOptions,
} from "@/queries/config/query-fetcher";
import { notificationQueryKeys } from "@/queries/query-keys/notifications";
import {
	type WorkflowNotification,
	WorkflowNotificationStatus,
} from "@/types/workflow";

export type Notification = WorkflowNotification & {
	workflow?: {
		id: string;
		name: string;
		description: string;
		workspaceId?: string;
		metadata?: {
			[key: string]: unknown;
			viewName: string;
			viewVisualizationId: string;
		};
	};
};

export type NotificationResponse = {
	notifications: Notification[];
};

const statuses = [
	WorkflowNotificationStatus.SENT,
	WorkflowNotificationStatus.VIEWED,
	WorkflowNotificationStatus.READ,
];

export function getWorkspaceUserNotifications(
	options?: RequestOptions,
): Promise<NotificationResponse> {
	return queryFetcher(`/api/notifications?statuses=${statuses.join(",")}`, {
		...options,
		method: "GET",
	});
}

export function getWorkspaceUserNotificationsSummary(
	options?: RequestOptions,
): Promise<{ unreadCount: number }> {
	return queryFetcher("/api/notifications?summary=unread", {
		...options,
		method: "GET",
	});
}

export function getWorkspaceUserNotificationsSummaryQueryOptions(
	workspaceId: string,
) {
	return queryOptions({
		enabled: Boolean(workspaceId),
		queryFn: getWorkspaceUserNotificationsSummary,
		queryKey: notificationQueryKeys.unreadSummary(workspaceId),
		refetchIntervalInBackground: false,
		refetchOnMount: false,
		refetchOnReconnect: true,
		staleTime: 55 * 1000,
	});
}

export function getWorkspaceUserNotificationsQueryOptions(
	workspaceId: string,
	{ enabled = true }: { enabled?: boolean } = {},
) {
	return queryOptions({
		enabled: Boolean(workspaceId) && enabled,
		placeholderData: keepPreviousData,
		queryFn: getWorkspaceUserNotifications,
		queryKey: notificationQueryKeys.list(workspaceId),
		refetchInterval: false,
		refetchIntervalInBackground: false,
		refetchOnReconnect: false,
		select: (data) => {
			const notifications = data?.notifications || [];

			const sortedNotifications = [...notifications].sort((left, right) => {
				if (
					left.status === WorkflowNotificationStatus.READ &&
					right.status !== WorkflowNotificationStatus.READ
				)
					return 1;
				if (
					left.status !== WorkflowNotificationStatus.READ &&
					right.status === WorkflowNotificationStatus.READ
				)
					return -1;
				return 0;
			});

			const unreadCount = notifications.filter(
				(notification) =>
					notification.status === WorkflowNotificationStatus.SENT,
			).length;

			return {
				...data,
				notifications: sortedNotifications,
				unreadCount,
			};
		},
		staleTime: 15 * 1000,
	});
}
